import React, { useState } from 'react';
import { GoGift } from "react-icons/go";
import { createSuscrito } from '../../actions/home';

export const Gift = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(email)) {
      setError('Por favor, introduce un correo electrónico válido.')
    } else {
      setError('')
      // lógica para enviar el correo
      // console.log('Correo enviado:', email)
      try {
        const response = await createSuscrito(email, 'campania')
        console.log('Suscrito creado:', response)
        setEmail('')
      } catch (error) {
        console.error('Error al crear suscrito', error)
        setError('Error al crear suscrito. Intentelo nuevamente')
      }
    }
  }

  return (
    <div div className='banner-gifts position-relative'>
      {/* <GoGift size={70} className='color-fff'/>
        <div className='color-fff font-27 mgb12 txt-negrita txt-envio-regalo'>Aquí tienes un <b>regalo:</b></div>    
        <div className='color-celeste txt-negrita font-27 mgb12 txt-envio'>Envío gratis</div>
        <div className='color-fff mgb12 font12-regalo parrafo-envio-gratis'>Solo escribe tu correo y te enviaremos el código. ¡Gracias!</div> */}

      <img
        src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=envio-gratis-xs.png&version_id=null"
        alt=""
        className="img-responsive"
      />

      <form onSubmit={handleSubmit} className='input-gifs position-absolute'>
        <input
          type='email'
          placeholder='Ingresa tu correo electrónico'
          className='input-frm font-family-montserrat'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          style={{
            height: '45px !important'
          }}
        />
        {/* <button type="submit">Enviar</button> */}
        {error && <div className='error-message'>{error}</div>}
      </form>
    </div>
  );
};